// extracted by mini-css-extract-plugin
module.exports = {"mobileContainerPadding":"LanguageSettingsPage_mobileContainerPadding__3O_IY","content":"LanguageSettingsPage_content__daY8e","title":"LanguageSettingsPage_title__2JiyP"};